module.exports = __webpack_public_path__ + "img/icon-commodities-big.d99b43ed.svg";